
import { mapGetters } from 'vuex'
export default {
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        ...mapGetters({
            mentionedGroups: 'ry/mentionedGroups',
            userinfo: 'user/userinfo'
        })
    },
    methods: {
        // 撤回文字
        recallText ({ latestMessage }) {
            if (!latestMessage.content || !Object.keys(latestMessage.content).length) {
                return ''
            }
            const { id, name } = latestMessage.content.user
            return id != this.userinfo.id ? `'${name}':` : '你'
        },
        isMentioned (targetId) {
            const _tempData = { ...this.mentionedGroups }
            const _conversations = Object.keys(_tempData)
            return _conversations.includes(targetId)
        },
        /**
         * 卡片消息文案
         */
        isPzType (messageType) {
            const pzTypes = [
                'panzhi:agencyOrderInfoConfirm',
                'panzhi:accountFrom',
                'panzhi:sellerInfoGather',
                'panzhi:sellerAccountGather',
                'panzhi:buyerInfoGather',
                'panzhi:buyerAccountGather',
                'panzhi:createGroupMsg',
                'panzhi:goodsLabelMsg',
                'panzhi:recyclingPayMsg',
                'panzhi:consultLabelMsg',
                'panzhi:modifyOrderMsg',
                'panzhi:taskOrderMsg',
                'panzhi:complaintEvaluateMsg'
            ]
            return pzTypes.includes(messageType)
        },
        /**
         * 融云默认Tip与 自定义卡片文案
         */
        customCardTypeText (messageType) {
            const type = {
                'RC:InfoNtf': '[系统提示]',
                'RC:ImgMsg': '[图片消息]',
                'RC:FileMsg': '[文件消息]',
                'RC:SightMsg': '[视频消息]',
                'panzhi:createOrderMsg': '[订单创建]',
                'panzhi:imCardMsg': '[提交卡片]',
                'panzhi:imCardMsgReply': '[提交卡片]',
                'panzhi:accountMsg': '[收款信息]',
                'panzhi:earnestOrderInfoMsg': '[订单消息]',
                'panzhi:bargainMessage': '[砍价消息]',
                'panzhi:payOnlineMsg': '[支付消息]',
                'panzhi:workOrderMsg': '[工单消息]',
                'panzhi:consultProductMsg': '[商品消息]',
                'panzhi:consultOrderMsg': '[订单咨询]',
                'panzhi:afterSalesGroupJoinMsg': '[入群消息]',
                'panzhi:afterSalesEvaluationMsg': '[评价卡片]',
                'panzhi:businessCardMsg': '[名片消息]',
                'panzhi:recyclingBargainingMsg': '[账号回收报价]',
                'panzhi:recycleBargainingMsg': '[回收商品卡片]',
                'panzhi:recyclePriceChangeMsg': '[回收商品改价卡片]',
                'panzhi:recyclingAgreeQuoteMsg': '[账号回收确认]',
                'panzhi:fictitiousOrderCreateMsg': '[订单确认]',
                'panzhi:indemnityUpdateMsg': '[包赔更新提示]',
                'panzhi:commissionfeeInfoMsg': '[订单消息]',
                'panzhi:questionnaire': '[问卷消息]',
                'panzhi:recycleGoodsGuideMsg': '[商品消息]',
                'panzhi:recycleGuideChangePriceMsg': '[改价引导]',
                'panzhi:labelOrderMsg': '[商品咨询回复]',
                'panzhi:orderUpdatePricePay': '[重新下单]',
                'panzhi:buyerSellerLinkMsg': '[商品消息]',
                'panzhi:linkPriceChangeMsg': '[改价卡片]',
                'panzhi:groupBanMsg': '[解除禁言]',
                'panzhi:aiViolationMsg': '[违规消息]',
                'panzhi:coalitionReminderMsg': '[规范提醒]'

            }
            return type[messageType] || ''
        }
    }
}
